import { render, staticRenderFns } from "./VTimeline.vue?vue&type=template&id=54d9ac44&"
import script from "./VTimeline.vue?vue&type=script&lang=js&"
export * from "./VTimeline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports